export const WORKSPACE_FEEDBACK_QUERY_KEY = ["workspace-feedback"] as const;
